(function (w) {
  function a11yAnnounce(message) {
    var el = document.getElementById('a11y-announcer');
    if (el) {
      el.textContent = '';
      setTimeout(function() { el.textContent = message; }, 100);
    }
  }

  var AjaxCart = function (selector, skin, events) {
    var me = this;
    this.skin = skin || 'default';
    this.isBasketChanged = false;
    this.isMobile = GLOBAL.isMobile;

    // TODO: This is a temporary solution with isAdminPage.
    // After improving the cart logic, the functionality on the order page in the admin panel should be improved.
    this.isAdminPage = this.skin === 'admin'

    var currentEvents = {
      onChange: function () {
        me.update();
      },
      onProductRemove: function (id, hash) {
        var container = me.container.find('#product_' + hash);
        if (!container.is('.j-remove-container')) {
          container = container.parents('.j-remove-container:first');
        }
        if (me.products.length > 1) {
          container.hide();
        }
        if (me.isAdminPage) me.reloadHtml()
        me.update();
        me.trigger('onProductRemoved');
        a11yAnnounce(l10n('Товар удален из корзины'));
      },
      onCouponChange: function (status, response) {
        if (status !== this.STATUS_COUPON_REJECTED) {
          me.reloadHtml();
          me.update();
        } else {
          me.coupon_code.errorBox(response.message);
        }
      },
      onReload: function () {
        me.reloadHtml();
      },
      onProductAdd: function () {
        if (me.isAdminPage) me.reloadHtml()
        me.initialized = false;
        me.isBasketChanged = true;
        a11yAnnounce(l10n('Товар добавлен в корзину'));
      },
      onInit: function () {
        me.init();
      },
      onError: function (errors) {

      },
      onQuantityChange: function (product, response) {
        if (me.isAdminPage) me.reloadHtml()
        me.trigger('onQuantityChanged');
        me.updateProduct(product);
        me.updateWholesalesProduct(product)
        me.updateTotal(response);
      },
      onBeforeAjax: function () {
        me.showCartLoader();
      },
      onAfterAjax: function () {
        me.hideCartLoader();
      }
    };

    this.container = $(selector);

    this.initialized   = false;
    this.interval      = null;
    this.products      = [];
    this.openCartOnAdd = false;
    this.isBusy        = false;

    Cart.AJAX_LINK = GLOBAL.URI_PREFIX + Cart.AJAX_LINK.substr(1);

    this.Cart = new Cart(
        AjaxCart.useSession,
        currentEvents,
        GLOBAL.currency.id,
        AjaxCart.id,
        this.container.data('initParams')
    );

    this.Cart.attachEventHandlers(events);

    this.init();
  };

  AjaxCart.selector               = "#cart";
  AjaxCart.skin                   = "default";
  AjaxCart.quantity_mask          = "{quantity} {products} {on}";
  AjaxCart.total_sum_wrapper      = "";
  AjaxCart.product_sum_wrapper    = "";
  AjaxCart.remove_product_on_zero = false;
  AjaxCart.events                 = {};

  AjaxCart.instance   = null;
  AjaxCart.useSession = true;
  AjaxCart.id         = undefined;

  /**
   *
   * @returns {AjaxCart}
   */
  AjaxCart.getInstance = function () {
    if (this.instance === null) {
      this.instance = new AjaxCart(this.selector, this.skin, this.events);
      w.dispatchEvent(new Event('AjaxCartInstanced')); // TODO переделать после релиза HOROSHOP-5043
    }

    return this.instance;
  };

  AjaxCart.prototype = {
    init: function () {
      var me = this;

      me.total_quantity   = me.container.find('.j-total-quantity');
      me.total_p_sum      = me.container.find('.j-total-p-sum');
      me.discount_percent = me.container.find('.j-discount-percent');
      me.discount_value   = me.container.find('.j-discount-value');
      me.total_sum        = me.container.find('.j-total-sum');

      me.coupon_code = me.container.find(".j-coupon-input");

      me.coupon_link             = me.container.find('.j-coupon-add');
      me.coupon_none             = me.container.find('.j-coupon-add-container');
      me.coupon_field            = me.container.find('.j-coupon-add-form');
      me.coupon_remove           = me.container.find('.j-coupon-remove');
      me.coupon_submit           = me.container.find('.j-coupon-submit');
      me.coupon_cancel           = me.container.find('.j-coupon-cancel');
      me.coupon_discount_value   = me.container.find('.j-coupon-discount-value');
      me.coupon_discount_tooltip = me.container.find('.j-coupon-discount-tooltip');

      me.initialized = true;
      me.initProducts();

      me.coupon_link.off('click').on('click', function () {
        me.coupon_none.hide();
        me.coupon_field.show();
        me.coupon_code.focus();

        return false;
      });

      me.coupon_remove.off('click').on('click', function () {

        if (confirm(l10n("Remove coupon?"))) {
          me.setCouponCode("", me.skin);
          me.coupon_none.show();
          me.coupon_field.hide();
        }

        return false;
      });

      me.coupon_cancel.off('click').on('click', function () {
        if (me.coupon_code.val() === '') {
          me.coupon_none.show();
          me.coupon_field.hide();
        } else {
          me.coupon_code.val('');
        }

        return false;
      });

      var coupon_code_change = function () {
        me.coupon_code.errorBox();
        if ($.trim(me.coupon_code.val()) !== "") {
          me.setCouponCode(me.coupon_code.val(), me.skin);
        }

        return false;
      };

      me.coupon_code.off('change, keydown').on('keydown', function (e) {
        if (e.which == 13) {
          coupon_code_change();
          return false;
        }

        return true;
      });
      me.coupon_submit.off('click').on('click', coupon_code_change);
      me.initialized = true;

      me.initManagerMarkup();
      me.initCustomDeliveryPrice();
      me.initProducts();

      me.attachEventHandler('onQuantityChange', function () {
        me.setIsBusy(false);
      })
    },

    initCustomDeliveryPrice: function () {
      var me = this;

      this.delivery_price                  = this.container.find('.j-delivery-price');
      this.custom_delivery_price_edit      = this.container.find('.j-custom-delivery-price-edit');
      this.custom_delivery_price_container = this.container.find('.j-custom-delivery-price-container');
      this.custom_delivery_price_input     = this.custom_delivery_price_container.find('.j-custom-delivery-price-input');
      this.custom_delivery_price_cancel    = this.custom_delivery_price_container.find('.j-custom-delivery-price-cancel');

      this.custom_delivery_price_edit.off('click').on('click', function () {
        me.delivery_price.hide();
        me.custom_delivery_price_edit.hide();
        me.custom_delivery_price_container.show();
        me.custom_delivery_price_input.focus();

        return false;
      });

      this.custom_delivery_price_input.off('change').on('change', function () {
        me.Cart.setCustomDeliveryPrice($(this).val());
      });

      this.custom_delivery_price_cancel.off('click').on('click', function () {
        me.Cart.setCustomDeliveryPrice(-1);

        me.delivery_price.show();
        me.custom_delivery_price_edit.show();
        me.custom_delivery_price_container.hide();
      });
    },

    initManagerMarkup: function () {
      var me = this;
      this.markup_add = this.container.find('.j-markup-add');
      this.markup_name = this.container.find('.j-markup-name');
      this.markup_price = this.container.find('.j-markup-price');
      this.markup_price_container = this.container.find('.j-markup-price-container');

      this.markup_name.off('change').on('change', function () {
        me.updateMarkup();
      });

      this.markup_price.numberMask({type: 'float', allowNegative: true}).off('change').on('change', function () {
        me.updateMarkup();
      });

      this.markup_add.off('click').on('click', function () {
        me.markup_add.hide();
        me.markup_name.show().focus();
        me.markup_price_container.show();
        return false;
      });
    },

    updateMarkup: function () {
      var me = this;
      this.Cart.setMarkup(this.markup_name.val(), this.markup_price.val(), function () {
        me.markup_name.val(me.Cart.manager_markup.markup_name);
        me.markup_price.val(me.Cart.manager_markup.markup_price);
      });
    },

    updateObject: function (object) {
      var me = this;
      var product = this.getProductByHash(object.hash);

      if (!product) {
        return;
      }

      if (object.quantity.is(':input')) {
        object.quantity.val(product.quantity);
      } else {
        object.quantity.html(product.quantity);
      }
      if (product.quantity === product.min_quantity && !me.remove_product_on_zero) {
        object.decrease.addClass('__disabled is-disabled');
      } else {
        object.decrease.removeClass('__disabled is-disabled');
      }
      if (product.quantity === product.max_quantity) {
        object.increase.addClass('__disabled is-disabled');
      } else {
        object.increase.removeClass('__disabled is-disabled');
      }
    },

    reloadHtml: function () {
      if (this.container.length !== 0) {
        var me = this;

        me.Cart.trigger('onBeforeReloadHtml');
        this.Cart.ajax('render/' + this.skin, {}, function (status, response) {
          if (status === 'OK') {
            me.container.empty().append($(response.html).html());
            me.init();
            me.Cart.trigger('onReloadHtml');
            me.isBasketChanged = false;
          }
        });
      }
    },

    /**
     * @param {Object} events
     */
    attachEventHandlers: function (events) {
      this.Cart.attachEventHandlers(events);
    },

    /**
     * @param {String} eventName
     * @param {Function} callback
     */
    attachEventHandler: function (eventName, callback) {
      this.Cart.attachEventHandler(eventName, callback);
    },

    trigger: function (fName) {
      return this.Cart.trigger.apply(this.Cart, arguments);
    },

    initProducts: function () {
      var me = this;
      this.products = [];

      this.container.find('.j-cart-product').each(function () {
        var obj = $(this),
            hash             = obj.attr('id').substr("product_".length),
            remove           = obj.find('.j-remove-p'),
            sum              = obj.find('.j-sum-p'),
            sum_old          = obj.find('.j-sum-old-p'),
            decrease         = obj.find('.j-decrease-p'),
            increase         = obj.find('.j-increase-p'),
            quantityUpdate   = obj.find('.j-wholesale-quantity-update'),
            input            = obj.find('.j-quantity-p'),
            step             = Number(input.attr('data-step')),
            min              = Number(input.attr('data-min')),
            quantity_reached = obj.find('.j-quantity-reached-message'),
            product_price    = obj.find('.j-price-p'),
            measurement_unit = product_price.attr('data-measurement-unit') !== undefined
                ? product_price.attr('data-measurement-unit')
                : "",
            initial_price    = obj.find('.j-initial-price-p'),
            admin_price      = obj.find('.j-admin-price-p');

        var product_object = {
          hash            : hash,
          container       : obj,
          sum             : sum,
          sum_old         : sum_old,
          remove          : remove,
          decrease        : decrease,
          increase        : increase,
          quantity        : input,
          product_price   : product_price,
          measurement_unit: measurement_unit,
          initial_price   : initial_price,
          admin_price     : admin_price
        };

        me.products.push(product_object);

        remove.off('click.AjaxCart').on('click.AjaxCart', function () {
          if (me.trigger('onBeforeProductRemove', product_object) !== false) {
            me.trigger('onProductRemoveConfirm');
            me.removeProductByHash(hash);
            me.trigger('onProductChange', hash);
          }
          return false;
        });

        decrease.off('click.AjaxCart').on('click.AjaxCart', function () {
          quantity_reached.hide().stop();
          var c_quantity = input.val() * 1;

          c_quantity = c_quantity - step;
          if (c_quantity > 0 && c_quantity < min) {
            c_quantity = min;
          }
          if (c_quantity > 0) {
            me.Cart.setProductQuantityByHash(hash, c_quantity);
            me.update();
            me.trigger('onProductChange', hash, c_quantity);
          } else if (me.remove_product_on_zero &&
              me.trigger('onBeforeProductRemove', product_object) !== false) {
            me.removeProductByHash(hash);
            me.trigger('onProductChange', hash);
          }

          return false;
        });

        increase.off('click.AjaxCart').on('click.AjaxCart', function () {
          quantity_reached.hide().stop();
          var c_quantity = Number(input.val()),
              product = me.getProductByHash(hash);

          if (product) {
            c_quantity = c_quantity + step;
            if (c_quantity <= product.max_quantity) {
              me.Cart.setProductQuantityByHash(hash, c_quantity);
              me.update();
              me.trigger('onProductChange', hash, c_quantity);
            } else {
              quantity_reached.stop().show().delay(3000).fadeOut('fast');
              me.trigger('onLimitReached');
            }
          }
          return false;
        });

        input.numberMask({type: 'int'}).off('change.AjaxCart').on('change.AjaxCart', function () {
          quantity_reached.hide().stop();
          var quantity = $(this).val() * 1,
              product = me.getProductByHash(hash);

          if ($(this).val() === 'more') {
            var input = $(this).parents('.select').hide().siblings('input').show();

            quantity = +input.data('start-quantity');

            input.val(quantity);
            me.setIsBusy(true);
            me.Cart.setProductQuantityByHash(hash, quantity);
            me.update();

            return false;
          }

          if (product) {
            if (quantity < min) {
              quantity = min;
            } else if (quantity > product.max_quantity) {
              quantity_reached.show().stop().delay(3000).fadeOut('fast');
              quantity = product.max_quantity;
            } else if (quantity % step !== 0) {
              quantity = (quantity - quantity % step) + step;
            }
            me.setIsBusy(true);
            me.Cart.setProductQuantityByHash(hash, quantity);
            me.trigger('onProductChange', hash, quantity);
            me.update();
          }

          return false;
        });

        quantityUpdate
          .off('click.AjaxCart')
          .on('click.AjaxCart', function () {
            var c_quantity = Number($(this).attr('data-quantity')),
              product = me.getProductByHash(hash);

            if (product) {
              if (c_quantity <= product.max_quantity) {
                me.Cart.setProductQuantityByHash(hash, c_quantity);
                me.update();
                me.trigger('onProductChange', hash, c_quantity);
              } else {
                quantity_reached.stop().show().delay(3000).fadeOut('fast');
              }
            }
            return false;
          });

        me.updateObject(product_object);
      });
    },

    setIsBusy: function (val) {
      this.isBusy = val;
    },

    getIsBusy: function () {
      return this.isBusy;
    },

    update: function () {
      var products = this.products,
          total = this.Cart.total,
          discount = this.Cart.discount,
          coupon_data = this.Cart.coupon_data;

      var total_p_sum = 0;

      var quantity_text = str_replace(
          ['{quantity}', '{products}', '{on}'],
          [total.quantity, getCountText(total.quantity), l10n("на")],
          AjaxCart.quantity_mask
      );

      this.total_quantity.html(quantity_text);
      this.discount_percent.html(discount.discount_percent);
      this.discount_value.html(discount.discount_value > 0 ? '&ndash; ' + this.priceFormat(discount.discount_value) : this.priceFormat(0));

      for (var i = 0, length = products.length; i < length; ++i) {
        var product = products[i],
            data = this.getProductByHash(product.hash);
        if (data) {
          total_p_sum += data.quantity * data.price;
          this.updateObject(product);
        }
      }

      this.total_p_sum.html(this.priceFormat(total_p_sum, AjaxCart.product_sum_wrapper));
      this.coupon_discount_value.html(coupon_data.sum > 0 ? '&ndash;' + this.priceFormat(coupon_data.sum, AjaxCart.product_sum_wrapper) : this.priceFormat(0));
      coupon_data.showTooltip ? this.coupon_discount_tooltip.show() : this.coupon_discount_tooltip.hide();
      this.isBasketChanged = true;
    },

    priceFormat: function (price, abbr_wrapper) {
      abbr_wrapper = abbr_wrapper || '';
      return currency.wrap_html(number_format(price, GLOBAL.round_to, '.', ' '), abbr_wrapper);
    },

    appendProduct: function (product, related, reloadBasket) {
      this.Cart.appendProduct(product, related, reloadBasket);
    },

    appendProducts: function (products) {
      this.Cart.appendProducts(products);
    },

    getProductByHash: function (hash) {
      return this.Cart.getProductByHash(hash);
    },

    getProductById: function (id) {
      return this.Cart.getProductById(id);
    },

    removeProductByHash: function (hash) {
      this.Cart.removeProductByHash(hash);
    },

    setCouponCode: function (code, skin) {
      this.Cart.setCouponCode(code, skin);
    },

    getProductObjByHash: function (hash) {
      for (var i = 0, l = this.products.length; i < l; ++i) {
        var product = this.products[i];
        if (product.hash == hash) {
          return product;
        }
      }

      return null;
    },

    measurementUnitsWrap: function(price, measurementUnit) {
        if(measurementUnit !== "") {
            return price + "/" + measurementUnit;
        }

        return price;
    },
    updateProduct: function (product) {
      if (!product) return
      const productElement = this.container.find(`#product_${product.hash}`);
      if (!productElement.length) return;

      const { discounted_price, initial_price } = product.cprice;
      const totalDiscountedPrice = priceFormat(discounted_price * product.quantity);
      const totalInitialPrice = priceFormat(initial_price * product.quantity);

      productElement.find('.j-cart-product-price-old').text(totalInitialPrice);
      productElement.find(`.j-cart-product-cost`).text(totalDiscountedPrice);
      productElement.find(`.j-cart-product-price`).text(priceFormat(discounted_price));

      const oldPriceElement = productElement.find(`.j-cart-product-price-old`);
      if (discounted_price === initial_price) {
        oldPriceElement.remove();
      } else if (!oldPriceElement.length) {
        this.setOldPrice(productElement, initial_price)
      } else {
        oldPriceElement.text(priceFormat(initial_price));
      }

      this.updateCoupon(productElement, this.isProductHasCoupon(product.id));
    },
    updateCoupon: function (productElement, isProductHasCoupon) {
      const prefix = productElement.find('#order-details').length ? 'order' : 'cart';

      const couponEl = productElement.find(`.j-${prefix}-coupon-sticker`);
      if (!isProductHasCoupon) {
        couponEl.remove();
        return
      }

      if(couponEl.length) {
        couponEl.html(`&ndash;${this.Cart.coupon_data?.percent}%`)
      } else {
        this.setCouponBlock(productElement, prefix)
      }
    },
    updateWholesalesProduct: function (product) {
      const productElement = this.container.find(`#product_${product.hash}`)
      if (!productElement) return

      if (!Object.keys(product.wholesales).length) {
        productElement.find('.j-wholesale-discount-link').remove()
        return
      }

      if (!productElement.find(`.j-wholesale-discount-link`).length) {
        this.setWholesaleDiscountBlock(
          productElement,
          product.wholesales.next_wholesale_quantity,
          product.wholesales.message
        );
      }

      productElement.find('.j-wholesale-quantity-update').attr('data-quantity', product.wholesales.next_wholesale_quantity);
      productElement.find('.j-wholesale-quantity-update-text').text(product.wholesales.message);
    },
    setWholesaleDiscountBlock: function (productElement, quantity, text) {
      const prefix = productElement.find('#order-details').length ? 'order' : 'cart';

      if (this.isMobile) {
        productElement.find(`.j-cart-item-content`).append(
          `<div class="cart-item__wholesale-discount j-wholesale-discount-link">
            <a href="javascript:void(0);" class="btn btn--xsmall btn--clear j-wholesale-quantity-update" data-quantity="${quantity}">
              <span class="cart-item__wholesale-discount-icon">
                <svg class="icon icon--plus">
                  <use xlink:href="#icon-plus"></use>
                </svg>
              </span>
              <span class="cart-item__wholesale-discount-text j-wholesale-quantity-update-text">${text}</span>
            </a>
          </div>`
        );
      } else {
        productElement.find(`#${prefix}-details`).append(
          `<div class="${prefix}-wholesale-discount j-wholesale-discount-link">
            <a href="javascript:void(0);" class="link link--pseudo j-wholesale-quantity-update" data-quantity="${quantity}">
              <span class="link__icon">
                <svg class="icon icon--plus"><use xlink:href="#icon-plus"></use></svg>
              </span>
              <span class="link__text j-wholesale-quantity-update-text">
                ${text}
              </span>
            </a>
          </div>`
        );
      }

      this.initProducts();
    },
    updateTotal: function (response) {
      if (this.total_sum.length) {
        const total_sum = response.total.total.complete_price ?? response.total.total.sum

        this.total_sum.text(priceFormat(total_sum))
      }
      const couponData = this.container.find('.j-coupon-data-sum')
      if (couponData.length) {
        couponData.text(` – ${priceFormat(response.total.coupon_data.sum)}`)
      }
      const deliveryData = this.container.find('.j-delivery-commission .j-delivery-commission-sum')
      if (response.total.hasOwnProperty('delivery') && deliveryData.length) {
        const deliveryPrice = response.total.delivery.price
        const deliveryText  = response.total.delivery.message

        deliveryData.text(deliveryPrice ? `${priceFormat(deliveryPrice)}` : deliveryText)
      }
      const paymentSystemData = this.container.find('.j-payment-commission')
      if (response.total.hasOwnProperty('payment_system_commission') && paymentSystemData.length) {
        if (response.total.payment_system_commission) {
          paymentSystemData.show()
          paymentSystemData.find('.j-payment-commission-sum').text(`${priceFormat(response.total.payment_system_commission)}`)
        } else {
          paymentSystemData.hide()
        }
      }
    },
    isProductHasCoupon: function (id) {
      return this.Cart.coupon_data?.products.includes(id);
    },
    setOldPrice: function (productElement, initial_price) {
      const prefix = productElement.find('#order-details').length ? 'order-i' : 'cart';

      if (this.isMobile) {
        productElement.find(`.j-cart-product-price`).after(
          `<div class="cart-item__price cart-item__price--old j-cart-product-price-old">${priceFormat(initial_price)}</div>`
        );
      } else {
        productElement.find(`.j-cart-product-price`).before(
          `<div class="${prefix}-price __old j-cart-product-price-old">${priceFormat(initial_price)}</div>`
        );
      }
    },
    setCouponBlock: function (productElement, prefix) {
      const classes = this.isMobile
        ? `cart-sticker cart-sticker--coupon j-${prefix}-coupon-sticker`
        : `${prefix}-sticker cart-coupon-sticker j-${prefix}-coupon-sticker 
          ${prefix === 'cart' ? 'cart-coupon-sticker--default' : 'cart-coupon-sticker--order'}`

      const couponBlock = `
        <div class="${classes}">
          &ndash;${this.Cart.coupon_data?.percent}%
        </div>`

      productElement.find(`.j-${prefix}-container`).prepend(couponBlock)
    },

    showCartLoader: function () {
      $('.j-cart-loader').show();
      if (typeof App !== 'undefined' && App.mmenu.isPanelOpened('cart-drawer')) {
        App.mmenu.getAPI('cart-drawer').showLoader();
      }
    },

    hideCartLoader: function () {
      $('.j-cart-loader').hide();
      if (typeof App !== 'undefined' && App.mmenu.isPanelOpened('cart-drawer')) {
        App.mmenu.getAPI('cart-drawer').hideLoader();
      }
    }
};
w.AjaxCart = AjaxCart;
})(window);
